import { render } from "./FormCheckboxes.vue?vue&type=template&id=3c6866be"
import script from "./FormCheckboxes.vue?vue&type=script&lang=js"
export * from "./FormCheckboxes.vue?vue&type=script&lang=js"

import exportComponent from "/home/pslcal/futaba-photo.net/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__